import type { Components } from '@mui/material/styles';

export default function MUICssBaseline(): Components['MuiCssBaseline'] {
  return {};
}
